'use client';

import type { ReactNode } from 'react';
import { Box, HStack, VStack } from '@terra/ui-styled-system';
import { Avatar } from '../../../../components/avatar';
import { LabelDefault, MetaDefault } from '../../../../components/typography';

type ChatMessageProps = {
  role: 'assistant' | 'user';
  header?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
};

export function ChatMessage({ role, header, footer, children }: ChatMessageProps) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      width="100%"
      gap={2}
      data-role={role}
    >
      {header}
      {children}
      {footer}
    </Box>
  );
}

export function ChatMessageHeader({
  name,
  role,
  avatarSrc,
}: {
  name: string;
  role?: string;
  avatarSrc?: string;
}) {
  return (
    <HStack mb={1.5} gap={2}>
      <Avatar name={name} src={avatarSrc} size="sm" />
      <VStack alignItems="start" gap={0}>
        <LabelDefault as="span" color="fg.default">
          {name}
        </LabelDefault>
        {role ? <MetaDefault color="fg.muted">{role}</MetaDefault> : null}
      </VStack>
    </HStack>
  );
}
